module.exports = __webpack_public_path__ + "9f3166a63200fb0221416d8163d91082.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/P28 -  TempleApproach -BigBattleEngagement.jpg
// module id = 150
// module chunks = 0